import styled, { css } from 'styled-components'
import { Link } from 'gatsby'

export const linkStyle = css`
  padding: 0.25rem;
  text-decoration: underline;
`

export const ExternalLink = styled.a`
  ${linkStyle}
`

export const InternalLink = styled(Link)`
  ${linkStyle}
`
